/**
 * WhatsApp Business-Scoped User ID (e.g. "BR.2348906845637211"): identifies
 * contacts that adopted a WhatsApp username and reach us without a phone.
 * Same format generic-bot checks before routing a send to Gupshup's `userId`.
 */
const BSUID_REGEX = /^[A-Z]{2,3}\.\d+$/;

export function isBsuid(value: string | null | undefined): boolean {
  return !!value && BSUID_REGEX.test(value);
}

/** Country prefix of a BSUID ("BR.2348906845637211" -> "BR"); undefined otherwise. */
export function getBsuidCountry(value: string | null | undefined): string | undefined {
  return value && isBsuid(value) ? value.split('.')[0] : undefined;
}
